import { render, staticRenderFns } from "./c-custom-component@.vue?vue&type=template&id=b5e9d540&"
import script from "./c-custom-component@.vue?vue&type=script&lang=ts&"
export * from "./c-custom-component@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports